import { render, staticRenderFns } from "./wcrd_sex_off.vue?vue&type=template&id=3a89bf51&scoped=true&"
import script from "./wcrd_sex_off.vue?vue&type=script&lang=js&"
export * from "./wcrd_sex_off.vue?vue&type=script&lang=js&"
import style0 from "./wcrd_sex_off.vue?vue&type=style&index=0&id=3a89bf51&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a89bf51",
  null
  
)

export default component.exports